export class ClockWorkProjectSummaryModel {
    constructor() {
        this.projectId = "";
        this.projectName = "";
        this.projectCode = "";
        this.totalTime = "";
        this.totalPercentage = "";
        this.totalTimeInMinutes = 0;
    }
}
export default class ClockWorkProjectSummary extends ClockWorkProjectSummaryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
